import { useQuery } from "@tanstack/react-query";
import {
  mvpApiGetJobTask,
  JobTaskDetailSchema,
} from "@augmodo/lebron-browser-client";

export function useFetchTask(
  jobId?: string,
  taskId?: string | null,
  enabled: boolean = true,
) {
  return useQuery({
    queryKey: ["fetch-task", jobId, taskId],
    queryFn: async () => {
      const response = await mvpApiGetJobTask({
        path: {
          job_id: jobId || "",
          task_id: taskId || "",
        },
      });

      if (response.error) {
        throw new Error(`Failed to fetch task: ${response.error}`);
      }

      return response.data as JobTaskDetailSchema;
    },
    enabled: !!jobId && !!taskId && enabled,
  });
}
